import { SortDirection } from '@app/modules/@core/core.types';

export const COUPONS_PAGE_SORT_SETTINGS = {
  sortDirection: SortDirection.desc,
  orderBy: 'generated',
};
